export default "__VITE_ASSET__C7YpitoE__"